(function(){
  'use strict';
  var S=window.__AIO_STORE_ID__,A=(window.__AIO_API__||'').replace(/\/$/,'');
  if(!S||!A)return;
  var SKIP=['cart','checkout','account','password','login','register'];
  function clean(h){return h.split('?')[0].split('#')[0].replace(/\/$/,'');}
  function skip(p){return SKIP.some(function(s){return p.indexOf('/'+s)===0;});}
  function go(){
    var d=location.origin,p=location.pathname;
    if(skip(p))return;
    var links=[];
    try{
      links=[].slice.call(document.querySelectorAll('a[href]'))
        .map(function(a){return a.href;})
        .filter(function(h){return h.indexOf(d)===0&&!skip(h.replace(d,''));})
        .map(function(h){return clean(h.replace(d,''))||'/';})
        .filter(function(h,i,a){return a.indexOf(h)===i;})
        .slice(0,150);
    }catch(e){}
    var t='other';
    if(p==='/'||p==='')t='home';
    else if(p.indexOf('/products/')===0)t='product';
    else if(p.indexOf('/collections/')===0)t='collection';
    else if(p.indexOf('/pages/')===0)t='page';
    else if(p.indexOf('/blogs/')===0)t='blog';
    var is4=false;
    try{
      is4=!!(document.querySelector('.template-404')||
             document.querySelector('[data-template="404"]')||
             (document.title&&document.title.toLowerCase().indexOf('not found')>=0));
    }catch(e){}
    var sid='';
    try{sid=sessionStorage.getItem('_aio')||Math.random().toString(36).slice(2);sessionStorage.setItem('_aio',sid);}catch(e){}
    var ref='';
    try{if(document.referrer&&document.referrer.indexOf(d)===0)ref=clean(document.referrer.replace(d,''));}catch(e){}
    var body=JSON.stringify({u:p,t:t,l:links,e:is4?1:0,r:ref,s:sid});
    try{
      navigator.sendBeacon(A+'/api/gsc/monitor/event/'+encodeURIComponent(S),new Blob([body],{type:'text/plain'}));
    }catch(ex){
      try{var x=new XMLHttpRequest();x.open('POST',A+'/api/gsc/monitor/event/'+encodeURIComponent(S),true);x.setRequestHeader('Content-Type','text/plain');x.send(body);}catch(e2){}
    }
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',go);}else{go();}
})();
